import { apiSlice } from 'api/apiSlice'
import { BillingInfo } from 'shared/types/BillingInfo'

const billingInfosApi = apiSlice.injectEndpoints({
  endpoints: build => ({
    createBillingInfo: build.mutation({
      query: body => ({
        app: 'sneakers',
        data: body,
        method: 'POST',
        url: '/web-api/v1/billing_infos',
      }),
    }),
    getBillingInfo: build.query({
      query: id => ({
        app: 'sneakers',
        cache: false,
        method: 'GET',
        url: `/web-api/v1/billing_infos/${id}?timestamp=${new Date().getTime()}`,
      }),
    }),
    getBillingInfos: build.query<{ billingInfos: BillingInfo[] }, void>({
      query: () => ({
        app: 'sneakers',
        cache: false,
        method: 'GET',
        url: `/web-api/v1/billing_infos/?timestamp=${new Date().getTime()}`,
      }),
    }),
    updateBillingInfo: build.mutation({
      query: ({ id, ...body }) => ({
        app: 'sneakers',
        data: body,
        method: 'PUT',
        url: `/web-api/v1/billing_infos/${id}`,
      }),
    }),
  }),
})

export const {
  useCreateBillingInfoMutation,
  useGetBillingInfoQuery,
  useGetBillingInfosQuery,
  useUpdateBillingInfoMutation,
} = billingInfosApi
